<template>
    <div id="myPaginator">
        <button class="page-button page-jump-button border-round-lg" :class="getSizeClass()" @click="firstPage">&lt;&lt;</button>
        <button class="page-button page-jump-button border-round-lg" :class="getSizeClass()" @click="previousPage">&lt;</button>
        <button v-for="p in visiblePages" :key="p" class="page-button border-round-lg" :class="getDynamicPageClass(p)"
            @click="changePage(p)">
            {{ p }}
        </button>
        <button class="page-button page-jump-button border-round-lg " :class="getSizeClass()" @click="nextPage">&gt;</button>
        <button class="page-button page-jump-button border-round-lg " :class="getSizeClass()" @click="lastPage">&gt;&gt;</button>
        <Dropdown class="border-round-lg p-0" v-model="selectedPage" :options="pagesDropList" style="margin: 0 5px 0 5px;"
            @change="pageSelectedInDropList" :pt="{
                trigger: {style: 'width: 28px;'},
                input: {style: 'padding: 6px 8px 6px 0px'}
            }"/>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { useMq } from "vue3-mq"

const props = defineProps({
    rowsPerPage: {
        type: Number,
        required: false,
        default: () => 20
    },
    totalRecords: {
        type: Number,
        required: true
    }
})

const emit = defineEmits(['page-selected'])

const mq = useMq();

// reactive properties
const visiblePages = ref([])
const pagesDropList = ref([])
const selectedPage = ref(1)

const visiblePagesLimit = 3

onMounted(async () => {
    calculateVisiblePagesAndDropList()
})

// watchs

// watching single source
watch(() => props.rowsPerPage, () => {
    calculateVisiblePagesAndDropList()
})

watch(() => props.totalRecords, () => {
    calculateVisiblePagesAndDropList()
})

// functions

const getDynamicPageClass = (p) => {
    const selectedClass = p === selectedPage.value ? 'page-selected' : ''
    return getSizeClass() + ' ' + selectedClass
}

const getSizeClass = () => {
    return mq.current === 'mobile' ? 'small-size-button' : 'big-size-button'
}

const calculateVisiblePagesAndDropList = () => {
    visiblePages.value = []
    pagesDropList.value = []
    const totalPages = Math.ceil(props.totalRecords / props.rowsPerPage)
    for (let i = 1; i <= totalPages; i++) {
        pagesDropList.value.push(i)
    }
    const pagesWithVisibleButtons = totalPages > visiblePagesLimit ? visiblePagesLimit : totalPages
    for (let i = 1; i <= pagesWithVisibleButtons; i++) {
        visiblePages.value.push(i)
    }
}

// events

const changePage = (p) => {
    selectedPage.value = p
    emit('page-selected', p - 1)
}

const firstPage = () => {
    selectedPage.value = 1
    emit('page-selected', 0)
}

const nextPage = () => {
    if (selectedPage.value + 1 <= pagesDropList.value.length) {
        selectedPage.value++
        emit('page-selected', selectedPage.value - 1)
    }
}

const previousPage = () => {
    if (selectedPage.value - 1 >= 1) {
        selectedPage.value--
        emit('page-selected', selectedPage.value - 1)
    }
}

const lastPage = () => {
    changePage(pagesDropList.value.length)
}

const pageSelectedInDropList = (page) => {
    changePage(page.value)
}

const resetPagination = () => {
    selectedPage.value = 1
}

defineExpose({
    resetPagination
});

</script>

<style scoped>
.page-button {
    background-color:var(--surface-50);
    border: none;
    margin: 4px 2px;
    font-family: The-Sans, Avenir, Helvetica, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.big-size-button {
    width: 40px;
    height: 40px;
    font-size: 16px;
}

.small-size-button {
    width: 36px;
    height: 36px;
    font-size: 11px;
}

.page-button:hover {
    cursor: pointer;
}

#myPaginator {
    text-align: center;
}

.page-button.page-selected {
    background-color: var(--blue-600);
    color: white;
    font-weight: 700;
}
</style>